import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@saucelabs/sl-component-buttons';
import { Col, Row } from 'react-flexbox-grid';
import { FormGroup, IconTooltip } from '@saucelabs/sl-component-form';

import VisaImage from '../images/visa.svg';
import MastercardImage from '../images/mastercard.svg';
import AmericanExpressImage from '../images/american_express.svg';
import DiscoverImage from '../images/discover.svg';
import Styles from './CreditCardComponent.styles';

const CreditCardComponent = ({
  canShowCreditCardError,
  isCardInputCompleted,
  handleReplaceCard,
  paymentMethod,
  paymentMethodCurrent,
  readOnlyCard,
  setReadOnlyCard,
}) => {
  const invalid = canShowCreditCardError && paymentMethodCurrent && !paymentMethodCurrent.isValid;
  const invalidCardMessage = !isCardInputCompleted ? 'Please enter your credit card number' : 'Invalid Credit Card';

  return (
    <>
      <Row className={readOnlyCard ? '' : Styles['hidden-row']}>
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <label className={Styles['card-highlighted-data']}>Card on File</label>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <label className={Styles['hidden-card-numbers']}>
                ⬤⬤⬤⬤ ⬤⬤⬤⬤ ⬤⬤⬤⬤
              </label>
              {' '}
              <label className={Styles['card-highlighted-data']}>
                {paymentMethod?.lastFour}
              </label>
              <label className={Styles['card-expired']}>
                Expires:
                {' '}
                {paymentMethod?.expires}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Button
                category="link"
                className={Styles['replace-card-button']}
                onClick={() => {
                  setReadOnlyCard(false);
                  handleReplaceCard();
                }}
              >
                Replace Existing Card
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        className={readOnlyCard ? Styles['hidden-row'] : ''}
        data-private
      >
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <label>Card Details</label>
            </Col>
          </Row>
          <Row>
            <Col
              md={6}
              xs={12}
            >
              <FormGroup
                className={invalid ? 'has-error' : ''}
              >
                <div
                  className={Styles['credit-card']}
                  data-recurly="card"
                />
                <IconTooltip
                  message={invalidCardMessage}
                  type="error"
                />
              </FormGroup>
            </Col>
            <Col
              className={Styles['allowed-credit-cards-container']}
              md={3}
              xs={12}
            >
              <VisaImage className={Styles['allowed-credit-cards']} />
              <MastercardImage className={Styles['allowed-credit-cards']} />
              <AmericanExpressImage className={Styles['allowed-credit-cards']} />
              <DiscoverImage className={Styles['allowed-credit-cards']} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

CreditCardComponent.propTypes = {
  canShowCreditCardError: PropTypes.bool.isRequired,
  handleReplaceCard: PropTypes.func,
  isCardInputCompleted: PropTypes.bool.isRequired,
  paymentMethod: PropTypes.shape({
    expires: PropTypes.string,
    lastFour: PropTypes.string,
  }),
  paymentMethodCurrent: PropTypes.shape({
    isValid: PropTypes.bool,
  }),
  readOnlyCard: PropTypes.bool.isRequired,
  setReadOnlyCard: PropTypes.func.isRequired,
};

CreditCardComponent.defaultProps = {
  handleReplaceCard: () => {},
  paymentMethod: null,
  paymentMethodCurrent: null,
};

export default CreditCardComponent;
